import { isWidgetTextProperty } from '@creative/elements/widget/utils';
import { FILTER_MAP } from '@domain/style';
import { getBoundingRectangleOfRotatedBox, getOuterBounds } from '@studio/utils/geom';
import { isGroupDataNode, isVideoNode, isWidgetNode, toFlatElementNodeList } from '../nodes/helpers';
import { getBoundingBoxOfElementWithState } from '../rendering';
export function calculateBoundingBox(nodes, state) {
    const boxes = nodes
        .map(node => {
        if (isGroupDataNode(node)) {
            return toFlatElementNodeList(node);
        }
        return node;
    })
        .flat()
        .map((node, _, array) => {
        if (array.length === 1) {
            return getBoundingBoxOfElementWithState(node, state, true);
        }
        // Multiple elements selected, include rotations in box size.
        return getBoundingRectangleOfRotatedBox(node);
    });
    return Object.assign({ rotationZ: 0 }, (boxes.length === 1 ? boxes[0] : getOuterBounds(...boxes)));
}
/**
 * Converts the `filter` object to a string.
 * @returns A string that can be used as a CSS value.
 */
export function getFilterString(filters) {
    const values = Object.entries(filters)
        .filter(([_, filter]) => (filter === null || filter === void 0 ? void 0 : filter.value) !== undefined)
        .map(([key, filter]) => {
        var _a;
        const filterUnit = (_a = FILTER_MAP[key]) === null || _a === void 0 ? void 0 : _a.unit;
        return `${key}(${filter.value.toFixed(0)}${filterUnit})`;
    });
    return values.join(' ');
}
/**
 * Checks if the element has a video that is hosted by Bannerflow.
 * Checks the video asset or the custom property 'url' for the video player widget.
 */
export function hasBannerflowHostedVideo(el, videoStorage) {
    if (isVideoNode(el) && el.videoAsset && isBannerflowHostedUrl(el.videoAsset.url, videoStorage)) {
        return true;
    }
    if (isWidgetNode(el)) {
        const props = el.customProperties.filter(prop => prop.name === 'url');
        const isBannerflowHosted = props.some(prop => isWidgetTextProperty(prop) && isBannerflowHostedUrl(prop.value.text, videoStorage));
        if (isBannerflowHosted) {
            return true;
        }
    }
    return false;
}
const isBannerflowHostedUrl = (url, videoStorage) => url.includes(videoStorage) || url.includes('video.bannerflow.com');
